<template src="./html/SendEmail.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth', 'item'],
		data () {
			return {
				modal: {
					selector: 'modal-send-email'
				},
				data: {
					to: null,
					copy: null,
					subject: null,
					message: null,
				},

				setting: null,
			}
		},
		created() {
			this.init()
		},
		mounted() {
			$(this.$refs.tagsInput).tagsinput({
				maxTags: 2,
			})
		},
		methods: {
			init() {
				this.getSetting()
			},
			open() {
				this.clearData()
				this.errors.clear()
				this.loadData()
				this.loadSetting()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getSetting() {
				this.$http.get('admin/management/setting/email/form/order')
					.then(response => {
						this.setting = response.body
					})
			},
			loadSetting() {
				if(this.setting) {
					if(this.setting.subject) {
						var reference = null
						if(this.item) {
							reference = this.item.id
						}
						this.data.subject = this.setting.subject.replace('{reference}', reference)
					}
					if(this.setting.message) {
						var name = null
						if(this.item) {
							if(this.item.customer) {
								if(this.item.customer.name) {
									name = this.item.customer.name
								}
							}
						}
						this.data.message = this.setting.message.replace('{customer_name}', name)
					}
				}
			},
			loadData() {
				if(this.item) {
					if(this.item.customer) {
						this.data.to = this.item.customer.email
					}
					if(this.item.provider) {
						this.data.to = this.item.provider.email
					}
				}
			},
			clearData() {
				this.data.to = null
				$(this.$refs.tagsInput).tagsinput('removeAll')
				this.data.copy = null
				this.data.subject = null
				this.data.message = null
			},
			validate(event) {
				event.stopPropagation()
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.send()
					}
					return result
				})
			},
			send() {
				var loading = Ladda.create(this.$refs.btnSend)
				loading.start()
				var copy = $(this.$refs.tagsInput).val()
				this.data.copy = copy
				this.$http.post('admin/management/orders/' + this.item.id + '/send/email', this.data)
				.then(response => {
					loading.stop()
					this.clearData()
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			copy() {
				var copyText = this.$refs.link
				copyText.select()
				document.execCommand("copy")
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/SendEmail.vue